import { type StudySwimlaneSelectDto, type StudyThreadSelectDto } from '@@types/api.types';
import { Modal } from '@components/core/modal.component';
import { ConfirmationModal } from '@components/shared/confirm-delete-modal.component';
import { type FC, useState } from 'react';
import { MeiaSwimlaneStageForm } from './meia-swimlane-stage-form.component';

type MeiaSwimlaneModalProps = {
  isOpen: boolean;
  onClose: () => void;
  studyId: string;
  swimlane: StudySwimlaneSelectDto;
  thread: StudyThreadSelectDto;
};

export const MeiaSwimlaneModal: FC<MeiaSwimlaneModalProps> = (props) => {
  const { isOpen, onClose, studyId, swimlane, thread } = props;
  const [isConfirmingClose, setIsConfirmingClose] = useState(false);

  return (
    <MeiaSwimlaneStageForm
      canEdit
      onDeleted={onClose}
      onSaved={onClose}
      studyId={studyId}
      swimlane={swimlane}
      thread={thread}
    >
      {({ deleteButton, formBody, getIsDirty, isUpdating, submit }) => {
        // Guard close paths (button, overlay, Escape) when the form has unsaved edits.
        const requestClose = (): void => {
          if (getIsDirty()) {
            setIsConfirmingClose(true);
            return;
          }
          onClose();
        };

        return (
          <>
            <Modal
              centered
              footer={{
                leftButton: deleteButton,
                rightButton: {
                  children: isUpdating ? 'Saving...' : 'Save',
                  disabled: isUpdating,
                  onClick: () => void submit(),
                },
              }}
              header={{ title: `Edit Stage · ${swimlane.phaseName}` }}
              isOpen={isOpen}
              onClose={requestClose}
              width="640px"
            >
              {formBody}
            </Modal>
            <ConfirmationModal
              cancelLabel="Keep Editing"
              confirmLabel="Discard Changes"
              description="Closing now will discard the unsaved Stage edits."
              isOpen={isConfirmingClose}
              onConfirm={onClose}
              setIsOpen={setIsConfirmingClose}
              title="Discard unsaved changes?"
            />
          </>
        );
      }}
    </MeiaSwimlaneStageForm>
  );
};
